<script setup lang="ts">
// One legal document named inside a consent sentence. Module 29 owns the documents (contract 29
// §3.4): a slug with a public page links out; one without opens 29's modal, which says honestly
// that the text is unavailable rather than showing a blank. Never a dead link.
import { ref } from 'vue'

import { LEGAL_HREFS, LegalDocumentModal, type LegalDocumentSlug } from '@/features/global-surface'

const props = defineProps<{ slug: LegalDocumentSlug; label: string }>()

const open = ref(false)
const href = LEGAL_HREFS[props.slug]
</script>

<template>
  <a
    v-if="href"
    class="font-medium text-info underline"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    >{{ label }}</a
  >
  <button
    v-else
    type="button"
    class="cursor-pointer border-0 bg-transparent p-0 font-medium text-info underline"
    @click="open = true"
  >
    {{ label }}
  </button>
  <LegalDocumentModal v-if="!href && open" v-model="open" :slug="slug" />
</template>
